export default __webpack_public_path__ + "static/media/Dstruc.ded50941.jfif";